import BaseApi from "./Api";

export interface RHIRound {
    scoreId: string;
    gameId: string | null;
    gameCode?: string | null;
    gameDate: number | null;
    courseName: string | null;
    scoreDifferential: number | null;
    adjustedGrossScore?: number;
    courseRatingEstimated: boolean;
    missingCourseData?: string[] | null;
    rank: number;
}

export interface RHIData {
    rhi: number | null;
    roundCount: number;
    rounds: RHIRound[];
}

export interface RhiBulkCapabilities {
    environment: string;
    databaseLabel: string;
    allowCalculate: boolean;
    allowReset: boolean;
    reasonCalculate: string | null;
    reasonReset: string | null;
}

export interface RhiBulkAdminStatus {
    capabilities: RhiBulkCapabilities;
    diagnostics: {
        scoresMissingDifferential: number;
        usersWithRhi: number;
        ongoingRhiAutomatic: boolean;
    };
}

class RHIApi extends BaseApi {
    url = "rhi";

    constructor() {
        super();
        this.setResourceUrl(this.url);
    }

    getPlayerRHI = (playerId: string): Promise<{ data: { data: RHIData } }> => {
        return this.instance({
            method: "get",
            url: `${this.url}/${playerId}`,
        });
    };

    recalculatePlayerRHI = (playerId: string): Promise<{ data: { data: { rhi: number | null } } }> => {
        return this.instance({
            method: "post",
            url: `${this.url}/${playerId}/recalculate`,
        });
    };

    calculateMissingDifferentials = (playerId: string): Promise<{ data: { data: RHIData & { calculatedScores: number } } }> => {
        return this.instance({
            method: "post",
            url: `${this.url}/${playerId}/calculate-missing`,
        });
    };

    markAllForRecalculation = (): Promise<{ data: { data: { modifiedCount: number; userCount: number } } }> => {
        return this.instance({
            method: "post",
            url: `${this.url}/mark-all-for-recalculation`,
        });
    };

    calculateAllMissing = (): Promise<{ data: { data: { totalUsersProcessed: number; totalScoresCalculated: number; totalErrors: number; duration: string } } }> => {
        return this.instance({
            method: "post",
            url: `${this.url}/calculate-all-missing`,
            timeout: 300000, // 5 minutes for bulk operations
        });
    };

    getBulkAdminStatus = (): Promise<{ data: { data: RhiBulkAdminStatus } }> => {
        return this.instance({
            method: "get",
            url: `${this.url}/admin/bulk-status`,
        });
    };
}

export default new RHIApi();
